import { INSTANCE, INSTANCELIST } from './API'

export const getUsers = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/users/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify({
                    ...filter,
                    disabled: { $ne: true },
                }),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getSingleUser = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { userId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/users/${userId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {},
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateUser = (form, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/users',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const EditUser = (form, token, userId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/users/${userId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const DeleteUser = (userId, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/users/${userId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: {
                disabled: true,
            },
        })
            .then(resolve)
            .catch(reject)
    })
